export default __webpack_public_path__ + "static/media/redux-flow-with-middleware.387c0a3b.png";